import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";
import { getKiosksPath } from "@core/schema/paths/getKiosksPath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";
import { getWebsitesPath } from "@core/schema/paths/getWebsitesPath.js";

export function getServicesEcommerce(tenant: Tenant): ServiceCardItem[] {
	return [
		{
			title: "Vývoj e-shopu od A do Z",
			desc: `Zajistíme grafický návrh [${getWebAppsPath(tenant)}][[webové aplikace]], informační architekturu i vývoj, abyste e-shop dostali na zlatém podnose.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Mobilní aplikace",
			desc: "Vlastní mobilní aplikací výrazně zlepšíte nákupní zážitek svých zákazníků.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Jazykové mutace webu",
			desc: "Prodáváte i v zahraničí? Vytvoříme e-shop ve více jazykových mutacích.",
			iconName: brackets,
			show: true,
		},
		{
			title: "CMS (administrační prostředí)",
			desc: "Vyvineme pohodlnou administraci (CMS), přes kterou budete celý e-shop spravovat.",
			iconName: brackets,
			show: true,
		},
		{
			title: "CRM (řízení vztahu se zákazníky)",
			desc: "Do e-shopu umíme zakomponovat systém pro řízení vztahu se zákazníky (CRM).",
			iconName: brackets,
			show: true,
		},
		{
			title: "ERP (podnikový informační systém)",
			desc: `Poradíme si také s [${getIntegrationsPath(tenant)}][[integrací]] vašeho ERP systému, abyste v podnikání měli pořádek.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Platební a další systémy",
			desc: "Zbavíme vás veškerých starostí s implementací platebních systémů i napojením na hardwarová zařízení.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Marketingové a analytické nástroje",
			desc: "Zprovozníme vám marketingové nástroje, abyste měli výkon online obchodu pod kontrolou.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Automatizace procesů",
			desc: "Postaráme se o automatizaci zakládání objednávek nebo o automatické rozesílky fakturace.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Skladová řešení (vč. RFID)",
			desc: "S efektivním skladovým řešením budete mít přehled o aktuálních zásobách.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Obsah e-shopu i SEO",
			desc: `Díky spolupráci s externími partnery pro vás umíme zajistit i obsah [${getWebsitesPath(tenant)}][[webu]] a práci na SEO.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Kiosková řešení",
			desc: `Máte i kamennou prodejnu? Pomůžeme vám propojit online a offline prodej pomocí [${getKiosksPath(tenant)}][[kiosků]].`,
			iconName: brackets,
			show: true,
		},
	];
}
